import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// material
import { Box, Drawer } from "@mui/material";
// hooks
import useResponsive from "../../hooks/useResponsive";
// components
import Logo from "../../components/Logo";
import Scrollbar from "../../components/Scrollbar";
import NavList from "./NavList";

// ----------------------------------------------------------------------

//  following style is used when we want the drawer to show up as fixed left nav
const DRAWER_WIDTH = 280;

// const RootStyle = styled("div")(({ theme }) => ({
//   [theme.breakpoints.up("lg")]: {
//     flexShrink: 0,
//     width: DRAWER_WIDTH,
//   },
// }));

// ----------------------------------------------------------------------

PortalSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function PortalSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive("up", "md");

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 3,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Logo size={75} />
      </Box>
      <NavList sx={{ flexDirection: "column", justifyContent: "flex-start" }} />
      {/* <NavSection navConfig={navConfig} /> */}

      <Box sx={{ flexGrow: 1 }} />

      {/*
      <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Stack
          alignItems="center"
          spacing={3}
          sx={{ pt: 5, borderRadius: 2, position: "relative" }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Typography gutterBottom variant="h6">
              Pin to Bottm?
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              do it here
            </Typography>
          </Box>
        </Stack>
      </Box> */}
    </Scrollbar>
  );

  return (
    <Drawer
      open={isOpenSidebar && !isDesktop}
      onClose={onCloseSidebar}
      PaperProps={{
        sx: { width: DRAWER_WIDTH },
      }}
    >
      {renderContent}
    </Drawer>
  );
}
